import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector } from 'hooks/useSelector';
import { ActivityIndicator } from 'components/BlockingLoader/ActivityIndicator';
import { theme } from 'lib/theme';
import { selectEngageIsLoading } from 'store/remote/engageSelectors';
import { EngageStore } from 'types/Engage';

type Props = {
  pageKey: string;
  section: keyof Pick<
    EngageStore['data'],
    'properties' | 'flats' | 'scheduledVisits'
  >;
};
export const EngageLoader: React.FC<Props> = ({ pageKey, section }) => {
  const isLoading = useSelector((state) =>
    selectEngageIsLoading(state, pageKey, section),
  );
  if (!isLoading) {
    return null;
  }
  return (
    <View
      style={[
        StyleSheet.absoluteFill,
        {
          zIndex: 2,
          alignItems: 'center',
          backgroundColor: `${theme.colors.background50}`,
          justifyContent: 'center',
        },
      ]}
    >
      <ActivityIndicator size={60} />
    </View>
  );
};
